import { StockQuantity } from '@Components/StorageStock/StockQuantity';
import type { Column } from '@synqo/frontend-component-library';
import type { StockRow } from './stockView';

const quantityColumn: Column<StockRow> = {
    name: 'quantity',
    label: 'Gewicht (t)',
    size: 150,
    disableColumnFilter: true,
    disableColumnSort: true,
    renderCell: ({ cellData }) => <StockQuantity value={cellData as number} />,
};

export const materialStockColumns: Readonly<Column<StockRow>>[] = [
    { name: 'label', label: 'Material', disableColumnFilter: true, disableColumnSort: true },
    quantityColumn,
];

export const avvStockColumns: Readonly<Column<StockRow>>[] = [
    { name: 'label', label: 'AVV', disableColumnFilter: true, disableColumnSort: true },
    quantityColumn,
];
